import React from 'react';
import { GlobalState } from '@leverege/ui-redux';
import { Attributes } from '@leverege/ui-attributes';
import Path from '@leverege/path';
import { Config } from '@leverege/plugin';
import Util from "./Util.js";
import Model from "../filter/GroupedTextFilterModel.js";
import Suggestions from "./Suggestions.js";
import Suggestion from "./Suggestion.js";
import { DelegateActions } from "../../../../imagine/dataSource/constants/index.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const getSuggestions = async (delegate, filter, search, objectType, api) => {
  const f = filter;
  const res = await api.child(`v1/interface/${delegate.getInterfaceUrl(DelegateActions.SEARCH)}`).get({
    filter: f ? {
      ...f,
      value: Model.toImagineValue(search, filter, objectType, {
        complete: false
      })
    } : null,
    limit: 100
  });
  const items = {};
  const toCheck = Model.getLastToken(search).toLowerCase();
  if (f?.fields && f.fields.length > 0) {
    f.fields.forEach(field => {
      let accessor = () => null;
      if (typeof field === 'string') {
        accessor = Path(field);
      } else if (typeof field === 'object' && field?.field) {
        accessor = Path(field.field);
      }
      res?.items.forEach(i => {
        const val = accessor.get(i);
        if (typeof val === 'string' && val.toLowerCase().includes(toCheck)) {
          items[val] = true;
        }
      });
    });
  } else {
    const attrs = Attributes.getAttributesFor(objectType);
    attrs.forEach(attr => {
      if (attr.valueType !== 'string' || !attr?.blueprint?.field) {
        return;
      }
      res?.items.forEach(i => {
        const val = attr.get(i);
        if (typeof val === 'string' && val.toLowerCase().includes(toCheck)) {
          items[val] = true;
        }
      });
    });
  }
  return Object.keys(items);
};
const updateSuggestions = opts => {
  const {
    delegate,
    filterModel,
    search,
    objectType
  } = opts;
  const filter = Model.toImagineFilter(filterModel, objectType);
  if (!search || Model.getLastToken(search).length < Config.get('ApiSuggestions', 'minSuggestionLength', 3)) {
    opts.setItems([]);
    return Promise.resolve([]);
  }
  // do this so we can get at the raw api object and not touch api-redux
  return new Promise(resolve => {
    process.nextTick(GlobalState.dispatch, async (dispatch, getState, {
      api
    }) => {
      const items = await getSuggestions(delegate, filter, search, objectType, api);
      opts.setItems(items);
      resolve(items);
    });
  });
};
function ApiSuggestion(props) {
  const {
    item,
    search
  } = props;
  const newSearch = Util.getNewSearch(search, item);
  const lastToken = Model.getLastToken(search);
  const match = newSearch?.toLowerCase().lastIndexOf(lastToken?.toLowerCase());
  if (!newSearch || match < 0 || newSearch?.toLowerCase() === search?.toLowerCase() || search?.toLowerCase().endsWith(item?.toLowerCase())) {
    return null;
  }
  const contents = /*#__PURE__*/_jsxs(_Fragment, {
    children: [newSearch.slice(0, match), /*#__PURE__*/_jsx("b", {
      children: newSearch.slice(match, match + lastToken.length)
    }), newSearch.slice(match + lastToken.length)]
  });
  return /*#__PURE__*/_jsx(Suggestion, {
    ...props,
    newSearch: newSearch,
    contents: contents
  });
}
export default function ApiSuggestions(props) {
  const apiSearchLongEnough = search => {
    return Util.searchLongEnough(Model.getLastToken(search));
  };
  return /*#__PURE__*/_jsx(Suggestions, {
    ...props,
    updateSuggestions: updateSuggestions,
    searchLongEnough: apiSearchLongEnough,
    suggestionClass: ApiSuggestion,
    minSuggestionLength: Config.get('ApiSuggestions', 'minSuggestionLength', 3),
    searchDebounceMs: Config.get('ApiSuggestions', 'searchDebounceMs', 500)
  });
}